import { render, staticRenderFns } from "./ThirdPartyServiceDestroyModal.vue?vue&type=template&id=9b28a708"
import script from "./ThirdPartyServiceDestroyModal.vue?vue&type=script&lang=js"
export * from "./ThirdPartyServiceDestroyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports